import 'slick-carousel'

export default class Carousel {
  constructor () {
    this.init()
  }

  init () {
    $('.three-items-carousel').each((index, element) => {
      const carousel = $(element).find('.carousel');
      carousel.slick({
        lazyLoad: 'ondemand',
        infinite: true,
        slidesToShow: 3,
        rows: 0,
        prevArrow: '<span class="slick-arrow-prev z-10"><svg xmlns="http://www.w3.org/2000/svg" width="9.907" height="12.824" viewBox="0 0 9.907 12.824"><path d="M400,300.5l-8.74,6,8.74,6" transform="translate(-390.374 -300.088)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1"/></svg></span>',
        nextArrow: '<span class="slick-arrow-next z-10"><svg xmlns="http://www.w3.org/2000/svg" width="9.907" height="12.824" viewBox="0 0 9.907 12.824"><path d="M391.258,300.5l8.74,6-8.74,6" transform="translate(-390.975 -300.088)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1"/></svg></span>',
        responsive: [
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });

      carousel.on('afterChange', function (event, slick) {
        let current = slick.currentSlide + 1;
        let total = slick.slideCount;
        let percentage = current / total * 100;
        $(element).find('.slide-index').css({ 'width': percentage + '%' });
      });

      carousel.on('swipe', function (event) {
        // prevent open lity
      });

      $(element).find('.sm-slick-arrow-prev').on('click', function () {
        carousel.slick('slickPrev');
      });

      $(element).find('.sm-slick-arrow-next').on('click', function () {
        carousel.slick('slickNext');
      });

      window.addEventListener('resize', function () {
        let current = carousel.slick('slickCurrentSlide') + 1;
        let total = $(element).find('.slide-index').data('total');
        let percentage = current / total * 100;
        $(element).find('.slide-index').css({ 'width': percentage + '%' });
      });
    });

    $('.media-carousel').each((index, element) => {
      $(element).slick({
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        rows: 0,
        autoplay: true,
        autoplaySpeed: 8000,
        fade: true,
        speed: 500,
        cssEase: 'linear',
        prevArrow: '<span class="slick-arrow slick-arrow-prev z-10"><svg xmlns="http://www.w3.org/2000/svg" width="9.907" height="12.824" viewBox="0 0 9.907 12.824"><path d="M400,300.5l-8.74,6,8.74,6" transform="translate(-390.374 -300.088)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1"/></svg></span>',
        nextArrow: '<span class="slick-arrow slick-arrow-next z-10"><svg xmlns="http://www.w3.org/2000/svg" width="9.907" height="12.824" viewBox="0 0 9.907 12.824"><path d="M391.258,300.5l8.74,6-8.74,6" transform="translate(-390.975 -300.088)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1"/></svg></span>',
      })
    });
  }

  getPercentage (slick) {

  }
}
